import useModelStoreModule from '@/views/models/common/useModelStoreModule'
import addressModel from '@/views/models/addresses/addressModel'
import customerModel from '@/views/models/customers/customerModel'

const {
  create,
  deleteOne,
} = useModelStoreModule(addressModel)

const {
  createChild,
} = useModelStoreModule(customerModel)

export default {
  name: 'addresses',
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    create: (ctx, itemData) => {
      // If customer_id is provided, create as child of customer
      if (itemData.customer_id) {
        return createChild(ctx, {
          id: itemData.customer_id,
          childResourceName: 'addresses',
          payload: itemData,
        })
      }
      // Otherwise, create as standalone address
      return create(ctx, itemData)
    },
    deleteOne,
  },
}
